<template>
    <div>
        <template v-for="activity in activities" >
        <action-button :state="activity.Enable" :hover-img="activity.HoverUrl"
                       :key="activity.ID"
                       :navigate-url="activity.NavigateUrl"></action-button>
        </template>

    </div>
</template>

<script>
    import axios from "axios"
    import actionButton from '../components/actionButton.vue'

    export default {
        name: "selector",
        components:{
            'action-button': actionButton,
        },
        data: function () {
            return {
                activities: [],
            }
        },
        async created(){
            try {
                let ts = +(new Date());
                let response = await axios.get(process.env.BASE_URL + "activities.json?ts="+ts);
                //let response = await axios.get(process.env.BASE_URL + 'activities.json' );
                this.activities = response.data.activities.filter(a=>a.Visible===1);

            }
            catch (e) {
                console.log(e);
            }
        }
    }
</script>

<style scoped>

</style>